module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0731.c5bba64a.jpg";